export default __webpack_public_path__ + "static/media/EricAtBeaujolais.1bcf43bd.jpg";